import { API_ROUTE } from "../constants/workerConstants";
import AxiosInstance from "./http.handlers";

export const loggedInUser = async (payload) => {
  return await AxiosInstance.post(`${API_ROUTE.AUTH.LOGGED_IN}`, payload)
    .then((response) => response)
    .catch((error) => error);
};
